module.exports = __webpack_public_path__ + "img/logo.a3a2eee0.webp";